import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'secure-loader',
  templateUrl: './secure-loader.component.html',
  styleUrls: ['./secure-loader.component.scss'],
})
export class SecureLoaderComponent implements OnInit {

  constructor() { }

  ngOnInit() {}

}
